export default __webpack_public_path__ + "static/media/squared-corners.d779c121.webp";